import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useScroll, useSpring } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { testObj, testResult, isDarkState } from "../atom";

const Wrapper = styled(motion.div)`
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
`;
const Container = styled(motion.div)`
  min-width: 30rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  scroll-snap-align: center;
  height: 100vh;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3rem 0px;
`;
const AskDiv = styled(motion.div)`
  background: url("img/bg${(props) => props.id}.png");
  background-size: 100% 100%;
  flex-shrink: 0;
  width: 90%;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Dragdiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;
const DragZone = styled(motion.div)`
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ScoreGrid = styled(motion.div)`
  display: grid;
  width: 83%;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 0.5rem;
  column-gap: 0.5rem;
  margin-top: 0.8rem;
`;
const ScoreBox = styled(motion.div)`
  background-color: transparent;
  place-self: center;
  width: 8.2rem;
  height: 7.8rem;
  border-radius: 20px;
  &:nth-child(2) {
    margin-bottom: 0.6rem;
    width: 7.4rem;
  }
  &:nth-child(1) {
    width: 7.7rem;
  }
  &:nth-child(3) {
    width: 7.3rem;
  }
  /* box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1), 0 10px 20px rgba(0, 0, 0, 0.1); */
  border: none;
`;
const AskContent = styled.p`
  margin-top: 1rem;
  width: 80%;
  text-align: center;
  line-height: 1.2;
  font-family: "Noto Sans KR", sans-serif;
  color: rgba(0, 0, 0);
  font-weight: 400;
  position: relative;
`;
const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem;
  height: 4rem;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1;
  border-bottom: 1.5px solid rgba(0, 0, 0, 1);
  background-color: rgba(255, 255, 255, 1);
  div i,
  div p {
    &:hover {
      cursor: pointer;
    }
  }
`;
const Footer = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    rgba(0, 0, 0, 0) 1px,
    rgba(255, 255, 255, 1) 1.5px
  );
  background-size: 4px 4px;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(1px);
`;
const ScoreBoxVariants = {
  hover: {
    rotateZ: -20,
    transition: { duration: 0.3, type: "spring", damping: 2 },
  },
  tap: {
    rotateZ: 20,
    transition: { duration: 0.2, type: "spring", damping: 2 },
  },
  initial: {
    opacity: 0,
  },
  end: {
    opacity: 1,
    transition: {
      duration: 0.2,
      delay: 0.3,
    },
  },
};
const DragZoneVariants = {
  initial: { opacity: 0 },
  end: {
    opacity: 1,
    transition: {
      duration: 0.3,
      delay: 0.2,
    },
  },
};
const WrapperVariants = {
  load: { opacity: 0, x: 500 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.5 },
  },
  exit: { opacity: 0, x: -500 },
};
const Svg = styled(motion.svg)`
  border: none;
`;
// const circle = {
//   start: {
//     pathLength: 0,
//     stroke: "rgba(221, 87, 137, 0.8)",
//   },
//   end: {
//     pathLength: [0, 0.33],

//     stroke: "rgba(221, 87, 137, 0.8)",
//     transition: {
//       duration: 0.3,
//     },
//   },
// };

function Page2() {
  const [btnView, setBtnView] = useState(false);
  const scrollRef = useRef(0);

  const handleScroll = () => {
    if (window.scrollY > scrollRef.current) {
      setBtnView(true);
    } else {
      setBtnView(false);
    }
    scrollRef.current = window.scrollY;
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const { state } = useLocation();
  const { id } = state;
  const { score1 } = state;
  const { score2 } = state;
  const { score3 } = state;

  const [score4, setScore4] = useState(0);
  const [score5, setScore5] = useState(0);
  const [score6, setScore6] = useState(0);

  const oneref = useRef(null);
  const tworef = useRef(null);
  const threeref = useRef(null);

  const cononeref = useRef(null);
  const contworef = useRef(null);
  const conthreeref = useRef(null);

  function getconRef(id) {
    if (id === 4) {
      return cononeref;
    } else if (id === 5) {
      return contworef;
    } else if (id === 6) {
      return conthreeref;
    }
  }

  function getRef(id) {
    if (id === 4) {
      return oneref;
    } else if (id === 5) {
      return tworef;
    } else if (id === 6) {
      return threeref;
    }
  }

  const onContent1Click = () => {
    cononeref.current?.scrollIntoView({ top: 0, behavior: "smooth" });
  };
  const onContent2Click = () => {
    contworef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
  };
  const onContent3Click = () => {
    conthreeref.current?.scrollIntoView({ top: 0, behavior: "smooth" });
  };

  const ref = useRef(null);

  const navigate = useNavigate();

  const { scrollYProgress: progressY } = useScroll();
  const { scrollY } = useScroll({ target: ref });

  const [isDropped, setIsDropped] = useState([]);
  useEffect(() => {
    setIsDropped([
      {
        id: 4,
        checked: false,
        scorenum: [
          {
            num: 1,
            dropped: false,
          },
          {
            num: 2,
            dropped: false,
          },
          {
            num: 3,
            dropped: false,
          },
          {
            num: 4,
            dropped: false,
          },
        ],
      },
      {
        id: 5,
        checked: false,
        scorenum: [
          {
            num: 1,
            dropped: false,
          },
          {
            num: 2,
            dropped: false,
          },
          {
            num: 3,
            dropped: false,
          },
          {
            num: 4,
            dropped: false,
          },
        ],
      },
      {
        id: 6,
        checked: false,
        scorenum: [
          {
            num: 1,
            dropped: false,
          },
          {
            num: 2,
            dropped: false,
          },
          {
            num: 3,
            dropped: false,
          },
          {
            num: 4,
            dropped: false,
          },
        ],
      },
    ]);
    const timer = setInterval(() => {
      window.addEventListener("scroll", handleScroll);
    }, 100);
    return () => {
      clearInterval(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [quest, setQuest] = useRecoilState(testObj);
  const setResult = useSetRecoilState(testResult);
  const [dragimg, setDragimg] = useState("");

  const getObjectById = (id) => {
    return quest.find((item) => item.testid === parseInt(id)) || {};
  };
  const testObject = getObjectById(id);
  const { questions } = testObject;

  const scaleX = useSpring(progressY, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  const nextPage = () => {
    scrollToTop();

    setResult((obj) =>
      obj.map((item) => {
        if (item?.idx === 1) {
          return {
            ...item,
            score: score1,
          };
        } else if (item?.idx === 2) {
          return {
            ...item,
            score: score2,
          };
        } else if (item?.idx === 3) {
          return {
            ...item,
            score: score3,
          };
        }
        return item;
      })
    );

    navigate("/page3", {
      state: {
        id: id,
        score4,
        score5,
        score6,
      },
    });
  };

  const DragandDrop = (x, ty, itemid, num, score) => {
    const { left, width } = getRef(itemid)?.current.getBoundingClientRect();

    if (num === 1) {
      setDragimg("img/3dsim1.png");
    } else if (num === 2) {
      setDragimg("img/3dsim2.png");
    } else if (num === 3) {
      setDragimg("img/3dsim3.png");
    } else if (num === 4) {
      setDragimg("img/3dsim4.png");
    }

    if (itemid === 4) {
      setScore4(score);
    } else if (itemid === 5) {
      setScore5(score);
    } else if (itemid === 6) {
      setScore6(score);
    }

    if (itemid === 4) {
      console.log(left, width);
      if (x >= left && x <= left + width) {
        setIsDropped((prevState) =>
          prevState.map((obj) => {
            if (obj?.id === itemid) {
              return {
                ...obj,
                checked: true,
                scorenum: obj?.scorenum?.map((scoreobj) => {
                  if (scoreobj?.num === num) {
                    return {
                      ...scoreobj,
                      dropped: true,
                    };
                  }
                  return scoreobj;
                }),
              };
            }
            return obj;
          })
        );
        setTimeout(() => {
          onContent2Click();
        }, 1000);
      }
    } else if (itemid === 5) {
      console.log(left, width);
      if (x >= left && x <= left + width) {
        setIsDropped((prevState) =>
          prevState.map((obj) => {
            if (obj?.id === itemid) {
              return {
                ...obj,
                checked: true,
                scorenum: obj?.scorenum?.map((scoreobj) => {
                  if (scoreobj?.num === num) {
                    return {
                      ...scoreobj,
                      dropped: true,
                    };
                  }
                  return scoreobj;
                }),
              };
            }
            return obj;
          })
        );
        setTimeout(() => {
          onContent3Click();
        }, 1000);
      }
    } else if (itemid === 6) {
      console.log(left, width);
      if (x >= left && x <= left + width) {
        setIsDropped((prevState) =>
          prevState.map((obj) => {
            if (obj?.id === itemid) {
              return {
                ...obj,
                checked: true,
                scorenum: obj?.scorenum?.map((scoreobj) => {
                  if (scoreobj?.num === num) {
                    return {
                      ...scoreobj,
                      dropped: true,
                    };
                  }
                  return scoreobj;
                }),
              };
            }
            return obj;
          })
        );
      }
    }
  };

  return (
    <Wrapper
      variants={WrapperVariants}
      initial="load"
      animate="show"
      exit="exit"
      id={id}
      ref={ref}
    >
      <HeaderDiv>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p
            onClick={() => {
              window.location.reload();
            }}
          >
            <i style={{ marginRight: 10 }} class="fa-solid fa-arrow-left"></i>
            Back
          </p>
        </div>
        <svg id="totalprogress" width="60" height="60" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="30" pathLength="1" />
          <motion.circle
            cx="50"
            cy="50"
            r="30"
            pathLength="1"
            id="indicator"
            style={{
              pathLength: progressY,
            }}
          />
        </svg>
      </HeaderDiv>
      {questions.slice(3, 6).map((item) => (
        <Container
          ref={getconRef(item.id)}
          style={{
            paddingBottom: item.id === 6 ? 650 : 0,
          }}
        >
          <AskDiv id={id}>
            <AskContent>{item.question}</AskContent>
          </AskDiv>
          <Dragdiv>
            <DragZone
              ref={getRef(item.id)}
              variants={DragZoneVariants}
              initial="initial"
              animate="end"
              style={{
                background: isDropped[item.id - 4]?.checked
                  ? `url(${dragimg}) center/cover no-repeat`
                  : "rgba(255, 255, 255, 1)",
                border: isDropped[item.id - 4]?.checked
                  ? "none"
                  : "4px dotted rgba(0,0,0,1)",
              }}
            >
              {isDropped[item.id - 4]?.checked ? null : <p>Drag</p>}
            </DragZone>
          </Dragdiv>
          <ScoreGrid>
            <ScoreBox
              onPanEnd={(e, info) => {
                console.log(isDropped[item.id - 4]);
                console.log(info.point.x, info.point.y);
                DragandDrop(info.point.x, info.point.y, item.id, 1, 2.5);
              }}
              style={{
                visibility: isDropped[item.id - 4]?.scorenum[0]?.dropped
                  ? "hidden"
                  : "block",
              }}
              variants={ScoreBoxVariants}
              drag
              whileHover="hover"
              whileTap="tap"
              initial="initial"
              animate="end"
              dragSnapToOrigin={true}
            >
              <Svg
                version="1.1"
                xmlns="http://www.w3.org/2000/Svg"
                x="0px"
                y="0px"
                width="100%"
                viewBox="0 0 1024 928"
              >
                <path
                  fill="rgba(255, 201, 0)"
                  opacity="1.000000"
                  stroke="none"
                  d="
M145.231750,379.505768 
   C149.766205,351.052368 157.108826,323.756714 167.169525,297.267059 
   C180.108780,263.198212 197.021576,231.157059 218.096054,201.361740 
   C244.968140,163.369736 277.069183,130.474869 314.519257,102.874619 
   C350.839203,76.107262 390.408844,55.626324 433.310699,41.434879 
   C457.888611,33.304790 482.951660,27.381695 508.480835,23.663353 
   C540.020081,19.069632 571.698364,17.641937 603.603088,20.482126 
   C634.723328,23.252487 665.324280,28.491081 695.056274,37.903198 
   C798.562073,70.669502 879.686340,132.604248 936.986511,225.129440 
   C963.287598,267.598907 981.015686,313.535950 991.242737,362.376404 
   C998.438599,396.740906 1001.674927,431.520294 1000.040649,466.590271 
   C998.831848,492.528229 995.406494,518.219360 989.677979,543.643555 
   C978.591858,592.846436 959.888733,638.880920 932.638306,681.231262 
   C888.416199,749.957642 829.596985,802.458984 755.691162,837.747742 
   C709.867981,859.627502 661.658569,873.250244 611.116211,877.859863 
   C566.080566,881.967285 521.325989,879.708374 477.032501,869.719482 
   C402.100403,852.821106 336.231873,818.557861 279.423431,766.990417 
   C238.869629,730.178101 206.794418,686.888123 182.820724,637.651123 
   C169.742447,610.790955 159.507156,582.789551 152.318054,553.841797 
   C141.946106,512.077759 137.760681,469.565277 139.941452,426.525391 
   C140.733139,410.900513 142.717087,395.383484 145.231750,379.505768 
M895.259888,222.225266 
   C858.108093,169.253525 810.781555,127.886971 753.502258,97.846275 
   C721.896545,81.270378 688.555176,69.399460 653.785950,61.672039 
   C634.282104,57.337326 614.468201,54.963959 594.462891,53.752323 
   C573.439819,52.479053 552.456116,52.665913 531.566467,54.545071 
   C498.592041,57.511322 466.545746,65.120697 435.404327,76.408974 
   C385.287964,94.575363 340.353424,121.373161 301.152466,157.559540 
   C260.715271,194.887161 229.291306,238.733536 206.936707,289.042389 
   C190.255539,326.583191 179.503662,365.720947 175.108505,406.606720 
   C171.656097,438.722778 171.916519,470.768707 176.388199,502.757629 
   C182.714005,548.010437 196.148575,591.072205 217.251511,631.597473 
   C254.864746,703.828613 309.443237,759.509460 381.062378,798.439941 
   C431.276489,825.735168 484.995483,841.456116 541.854309,845.394531 
   C588.527405,848.627441 634.644287,844.068054 679.741577,830.755310 
   C729.531372,816.057190 774.997986,793.000671 815.671448,760.754395 
   C878.635376,710.835754 922.165649,647.371460 947.252319,571.087219 
   C957.706238,539.298462 963.692017,506.768982 965.993591,473.394684 
   C968.769836,433.136627 964.872437,393.514374 955.314636,354.499664 
   C943.668762,306.961792 923.757019,262.993866 895.259888,222.225266 
z"
                />
                <path
                  fill="rgba(255, 201, 0)"
                  opacity="1.000000"
                  stroke="none"
                  d="
M445.918335,629.070923 
   C475.457977,653.631287 507.077393,674.086487 542.832642,687.662415 
   C576.838501,700.574097 611.966614,705.525818 648.222107,702.225342 
   C696.500854,697.830444 739.549072,679.179016 780.049133,653.692871 
   C813.183594,632.841797 843.091003,607.922668 871.248779,580.826965 
   C873.289307,578.863525 875.275635,576.824524 877.465027,575.038757 
   C883.911743,569.780701 891.911621,570.224121 897.212952,576.008728 
   C902.528748,581.809021 902.391235,589.815186 896.642639,595.803406 
   C885.436951,607.475952 873.261475,618.124084 861.042114,628.694153 
   C835.539490,650.754395 808.469421,670.641235 779.145752,687.422485 
   C743.540161,707.798706 705.895508,722.613098 665.198181,728.596680 
   C628.873779,733.937317 592.911560,731.965271 557.352051,721.951599 
   C508.264374,708.128235 465.991150,682.308960 427.229126,649.961182 
   C400.013336,627.248901 375.777374,601.610962 352.831268,574.684387 
   C349.139038,570.351624 345.628998,565.979065 345.251160,559.607239 
   C339.041840,561.293884 333.528503,563.060669 327.895782,564.272644 
   C308.600403,568.424805 289.497070,566.962708 270.613831,561.699402 
   C265.648132,560.315308 260.699707,558.776855 255.902405,556.902222 
   C248.166611,553.879395 244.783737,546.021240 247.655594,538.497131 
   C250.387955,531.338501 258.104065,527.939575 265.782898,530.759216 
   C277.590729,535.095093 289.743073,538.117737 302.276062,538.600281 
   C328.404694,539.606079 349.279327,528.491028 366.412964,509.440979 
   C376.979797,497.692291 384.804749,484.153839 391.936218,470.169006 
   C392.465851,469.130341 392.922089,468.053833 393.462372,467.021057 
   C397.205505,459.866180 405.238190,456.698120 412.002533,459.695618 
   C419.196777,462.883667 422.451477,470.982849 419.000580,478.584076 
   C411.743988,494.568024 402.766113,509.542969 391.615662,523.160767 
   C385.899323,530.142029 379.688843,536.614807 372.626465,542.270020 
   C370.715057,543.800537 368.588165,545.247131 367.352936,548.037048 
   C391.038116,577.192444 416.792053,604.509216 445.918335,629.070923 
z"
                />
                <path
                  fill="rgba(255, 201, 0)"
                  opacity="1.000000"
                  stroke="none"
                  d="
M790.051514,313.710815 
   C797.677063,319.078186 799.296814,326.114502 797.726501,334.588684 
   C795.933960,344.262177 792.791565,353.563873 790.434631,363.078247 
   C788.229126,371.981537 779.525940,376.998596 770.802063,375.114990 
   C762.080566,373.231873 755.978149,364.128540 758.087585,354.918854 
   C760.569580,344.082794 763.835327,333.450073 766.146851,322.534698 
   C768.175415,312.955353 780.765076,308.355133 790.051514,313.710815 
z"
                />
                <path
                  fill="rgba(255, 201, 0)"
                  opacity="1.000000"
                  stroke="none"
                  d="
M666.315125,359.215424 
   C663.806458,365.472748 661.530151,371.355682 655.008972,374.188324 
   C648.837219,376.869263 643.197632,375.929504 638.162842,371.881744 
   C632.965942,367.703613 630.666748,362.113281 632.287170,355.468262 
   C633.068970,352.262512 634.517090,349.213104 635.735657,346.121368 
   C638.109436,340.098602 640.797546,334.231415 642.030701,327.766449 
   C643.967224,317.613495 651.813049,312.864227 662.634033,314.812561 
   C670.569397,316.241333 676.047791,324.406708 674.864441,333.362427 
   C673.673767,342.373718 670.085144,350.635132 666.315125,359.215424 
z"
                />
              </Svg>
            </ScoreBox>
            <ScoreBox
              onPanEnd={(e, info) => {
                console.log(isDropped[item.id - 4]);

                DragandDrop(info.point.x, info.point.y, item.id, 2, 5);
              }}
              style={{
                visibility: isDropped[item.id - 4]?.scorenum[1]?.dropped
                  ? "hidden"
                  : "block",
              }}
              variants={ScoreBoxVariants}
              drag
              whileHover="hover"
              whileTap="tap"
              initial="initial"
              animate="end"
              dragSnapToOrigin={true}
            >
              <Svg
                version="1.1"
                xmlns="http://www.w3.org/2000/Svg"
                x="0px"
                y="0px"
                width="100%"
                viewBox="0 0 1016 1000"
              >
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M570.000000,1001.000000 
   C380.000000,1001.000000 190.500000,1001.000000 1.000000,1001.000000 
   C1.000000,667.666687 1.000000,334.333344 1.000000,1.000000 
   C339.666656,1.000000 678.333313,1.000000 1017.000000,1.000000 
   C1017.000000,334.333344 1017.000000,667.666687 1017.000000,1001.000000 
   C868.166687,1001.000000 719.333313,1001.000000 570.000000,1001.000000 
M891.905701,793.441101 
   C896.231689,787.531677 900.753967,781.754944 904.854187,775.692871 
   C962.287659,690.777344 989.048279,597.315857 983.188660,494.720154 
   C980.389832,445.715179 969.592773,398.521881 950.897949,353.232300 
   C911.435730,257.632416 846.603271,184.058228 756.622681,133.193008 
   C685.305176,92.877823 608.354187,73.944183 526.336487,75.943512 
   C483.242004,76.994003 441.191803,84.204536 400.296021,97.667580 
   C317.176941,125.030693 247.407562,172.161362 192.285492,240.293457 
   C129.816818,317.506073 96.497673,405.968811 92.318008,505.180908 
   C89.797684,565.005554 99.575943,622.967529 120.712669,679.021912 
   C149.479843,755.312073 195.551636,819.192139 259.228424,869.963440 
   C326.596069,923.677307 403.316528,955.482300 489.096283,965.194031 
   C528.589844,969.665344 567.957520,968.799866 607.143738,962.594604 
   C645.786377,956.475464 683.039307,945.438782 718.861511,929.538452 
   C787.859802,898.912170 845.248657,853.593872 891.905701,793.441101 
z"
                />
                <path
                  fill="#FDC905"
                  opacity="1.000000"
                  stroke="none"
                  d="
M891.677490,793.713501 
   C845.248657,853.593872 787.859802,898.912170 718.861511,929.538452 
   C683.039307,945.438782 645.786377,956.475464 607.143738,962.594604 
   C567.957520,968.799866 528.589844,969.665344 489.096283,965.194031 
   C403.316528,955.482300 326.596069,923.677307 259.228424,869.963440 
   C195.551636,819.192139 149.479843,755.312073 120.712669,679.021912 
   C99.575943,622.967529 89.797684,565.005554 92.318008,505.180908 
   C96.497673,405.968811 129.816818,317.506073 192.285492,240.293457 
   C247.407562,172.161362 317.176941,125.030693 400.296021,97.667580 
   C441.191803,84.204536 483.242004,76.994003 526.336487,75.943512 
   C608.354187,73.944183 685.305176,92.877823 756.622681,133.193008 
   C846.603271,184.058228 911.435730,257.632416 950.897949,353.232300 
   C969.592773,398.521881 980.389832,445.715179 983.188660,494.720154 
   C989.048279,597.315857 962.287659,690.777344 904.854187,775.692871 
   C900.753967,781.754944 896.231689,787.531677 891.677490,793.713501 
M139.104141,415.801422 
   C137.145126,424.055695 134.853577,432.247314 133.284164,440.574982 
   C126.158714,478.384247 123.283264,516.405945 126.628578,554.898071 
   C129.453018,587.396973 135.656219,619.129700 145.775833,650.080200 
   C160.811966,696.067566 183.120209,738.249512 213.027481,776.332886 
   C249.661346,822.981750 294.243469,860.123291 346.849701,887.540344 
   C397.541809,913.959839 451.365173,929.261780 508.446594,933.533325 
   C542.058167,936.048584 575.384949,934.262207 608.473389,928.600647 
   C638.223267,923.510315 667.076416,915.020447 695.037170,903.462219 
   C770.331360,872.337830 831.272949,823.360352 877.527222,756.390625 
   C919.379578,695.794312 943.171143,628.633972 949.410461,555.150208 
   C953.240845,510.038300 949.363098,465.637177 938.472412,421.863861 
   C928.775391,382.888275 913.699829,346.011108 893.092529,311.433716 
   C852.578308,243.454285 797.133545,191.313950 726.909424,154.998138 
   C678.291504,129.855835 626.630432,115.200981 572.005066,110.544327 
   C523.661011,106.423126 476.211792,111.019142 429.540314,123.671440 
   C382.520264,136.418243 339.016418,156.880875 299.270691,185.155685 
   C243.217499,225.031494 199.923294,275.856934 168.959503,337.233734 
   C156.397293,362.134705 146.762177,388.158630 139.104141,415.801422 
z"
                />
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M139.194427,415.402161 
   C146.762177,388.158630 156.397293,362.134705 168.959503,337.233734 
   C199.923294,275.856934 243.217499,225.031494 299.270691,185.155685 
   C339.016418,156.880875 382.520264,136.418243 429.540314,123.671440 
   C476.211792,111.019142 523.661011,106.423126 572.005066,110.544327 
   C626.630432,115.200981 678.291504,129.855835 726.909424,154.998138 
   C797.133545,191.313950 852.578308,243.454285 893.092529,311.433716 
   C913.699829,346.011108 928.775391,382.888275 938.472412,421.863861 
   C949.363098,465.637177 953.240845,510.038300 949.410461,555.150208 
   C943.171143,628.633972 919.379578,695.794312 877.527222,756.390625 
   C831.272949,823.360352 770.331360,872.337830 695.037170,903.462219 
   C667.076416,915.020447 638.223267,923.510315 608.473389,928.600647 
   C575.384949,934.262207 542.058167,936.048584 508.446594,933.533325 
   C451.365173,929.261780 397.541809,913.959839 346.849701,887.540344 
   C294.243469,860.123291 249.661346,822.981750 213.027481,776.332886 
   C183.120209,738.249512 160.811966,696.067566 145.775833,650.080200 
   C135.656219,619.129700 129.453018,587.396973 126.628578,554.898071 
   C123.283264,516.405945 126.158714,478.384247 133.284164,440.574982 
   C134.853577,432.247314 137.145126,424.055695 139.194427,415.402161 
M732.053467,704.627014 
   C686.986389,730.923950 639.957947,751.806824 587.376831,757.689270 
   C558.007629,760.974915 529.193237,758.638672 500.956512,749.925964 
   C466.058502,739.157837 436.262024,719.816406 409.699646,695.132996 
   C390.836823,677.604553 374.434784,657.945068 359.287811,637.171936 
   C357.587769,634.840393 357.271820,633.281250 358.414825,630.578003 
   C362.636871,620.593018 366.472107,610.416138 365.996582,599.297485 
   C365.591034,589.815796 358.347046,582.950256 349.183777,583.052368 
   C340.233704,583.152039 333.417847,590.013611 332.905579,599.290771 
   C332.787567,601.427368 332.453186,603.599792 331.867035,605.655579 
   C326.145172,625.724365 314.812439,642.286621 299.970367,656.685730 
   C292.634949,663.802185 292.226135,673.930359 298.760132,680.770813 
   C305.272888,687.588928 315.341431,687.446411 322.953461,680.653625 
   C328.370239,675.819946 334.016907,671.243958 339.425842,666.667236 
   C345.803253,674.352844 353.027863,683.498718 360.710114,692.242554 
   C396.841675,733.367310 438.965057,765.787476 492.095856,782.101379 
   C516.668396,789.646484 541.841980,793.030884 567.475708,792.386230 
   C603.447021,791.481750 638.055359,783.537292 671.612244,770.836609 
   C714.855530,754.469788 754.619812,731.652100 792.353210,705.151550 
   C798.860291,700.581604 800.954956,691.937927 797.768982,685.095886 
   C793.120178,675.112610 782.178406,672.273132 772.536011,678.507385 
   C759.253967,687.094849 745.950928,695.649902 732.053467,704.627014 
M734.538452,422.138123 
   C734.413147,422.790833 734.244202,423.438599 734.169067,424.097015 
   C732.986877,434.454346 738.605042,442.609406 747.848877,443.971710 
   C757.266479,445.359619 764.956299,439.492493 767.038696,429.367554 
   C767.305481,428.070404 767.775452,426.816437 768.099365,425.529419 
   C770.245483,417.002411 772.760437,408.545258 774.413147,399.923096 
   C776.317871,389.986511 770.183594,381.319427 760.690430,379.443939 
   C752.282715,377.782898 743.517517,383.554901 741.456970,392.235016 
   C739.160767,401.908234 736.981262,411.609161 734.538452,422.138123 
M625.552185,443.117981 
   C628.218445,440.986969 632.170227,439.394196 633.327026,436.631195 
   C638.176636,425.047974 642.960327,413.324432 646.254089,401.239624 
   C648.706360,392.242615 642.436096,384.486420 633.352417,382.524323 
   C624.463745,380.604401 616.887024,385.098022 613.879700,393.895508 
   C610.779053,402.965729 607.630554,412.022369 604.311218,421.014191 
   C601.827271,427.742950 602.598999,433.828491 607.569824,439.019043 
   C612.327820,443.987457 618.124023,445.709290 625.552185,443.117981 
z"
                />
                <path
                  fill="#FDC906"
                  opacity="1.000000"
                  stroke="none"
                  d="
M732.355164,704.422974 
   C745.950928,695.649902 759.253967,687.094849 772.536011,678.507385 
   C782.178406,672.273132 793.120178,675.112610 797.768982,685.095886 
   C800.954956,691.937927 798.860291,700.581604 792.353210,705.151550 
   C754.619812,731.652100 714.855530,754.469788 671.612244,770.836609 
   C638.055359,783.537292 603.447021,791.481750 567.475708,792.386230 
   C541.841980,793.030884 516.668396,789.646484 492.095856,782.101379 
   C438.965057,765.787476 396.841675,733.367310 360.710114,692.242554 
   C353.027863,683.498718 345.803253,674.352844 339.425842,666.667236 
   C334.016907,671.243958 328.370239,675.819946 322.953461,680.653625 
   C315.341431,687.446411 305.272888,687.588928 298.760132,680.770813 
   C292.226135,673.930359 292.634949,663.802185 299.970367,656.685730 
   C314.812439,642.286621 326.145172,625.724365 331.867035,605.655579 
   C332.453186,603.599792 332.787567,601.427368 332.905579,599.290771 
   C333.417847,590.013611 340.233704,583.152039 349.183777,583.052368 
   C358.347046,582.950256 365.591034,589.815796 365.996582,599.297485 
   C366.472107,610.416138 362.636871,620.593018 358.414825,630.578003 
   C357.271820,633.281250 357.587769,634.840393 359.287811,637.171936 
   C374.434784,657.945068 390.836823,677.604553 409.699646,695.132996 
   C436.262024,719.816406 466.058502,739.157837 500.956512,749.925964 
   C529.193237,758.638672 558.007629,760.974915 587.376831,757.689270 
   C639.957947,751.806824 686.986389,730.923950 732.355164,704.422974 
z"
                />
                <path
                  fill="#FCC908"
                  opacity="1.000000"
                  stroke="none"
                  d="
M734.644653,421.718079 
   C736.981262,411.609161 739.160767,401.908234 741.456970,392.235016 
   C743.517517,383.554901 752.282715,377.782898 760.690430,379.443939 
   C770.183594,381.319427 776.317871,389.986511 774.413147,399.923096 
   C772.760437,408.545258 770.245483,417.002411 768.099365,425.529419 
   C767.775452,426.816437 767.305481,428.070404 767.038696,429.367554 
   C764.956299,439.492493 757.266479,445.359619 747.848877,443.971710 
   C738.605042,442.609406 732.986877,434.454346 734.169067,424.097015 
   C734.244202,423.438599 734.413147,422.790833 734.644653,421.718079 
z"
                />
                <path
                  fill="#FCC908"
                  opacity="1.000000"
                  stroke="none"
                  d="
M625.192505,443.241241 
   C618.124023,445.709290 612.327820,443.987457 607.569824,439.019043 
   C602.598999,433.828491 601.827271,427.742950 604.311218,421.014191 
   C607.630554,412.022369 610.779053,402.965729 613.879700,393.895508 
   C616.887024,385.098022 624.463745,380.604401 633.352417,382.524323 
   C642.436096,384.486420 648.706360,392.242615 646.254089,401.239624 
   C642.960327,413.324432 638.176636,425.047974 633.327026,436.631195 
   C632.170227,439.394196 628.218445,440.986969 625.192505,443.241241 
z"
                />
              </Svg>
            </ScoreBox>
            <ScoreBox
              onPanEnd={(e, info) => {
                console.log(isDropped[item.id - 4]);

                DragandDrop(info.point.x, info.point.y, item.id, 3, 7.5);
              }}
              style={{
                visibility: isDropped[item.id - 4]?.scorenum[2]?.dropped
                  ? "hidden"
                  : "block",
              }}
              variants={ScoreBoxVariants}
              drag
              whileHover="hover"
              whileTap="tap"
              initial="initial"
              animate="end"
              dragSnapToOrigin={true}
            >
              <Svg
                version="1.1"
                xmlns="http://www.w3.org/2000/Svg"
                x="0px"
                y="0px"
                width="100%"
                viewBox="0 0 1016 1000"
              >
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1017.000000,376.000000 
   C1017.000000,584.666687 1017.000000,792.833313 1017.000000,1001.000000 
   C678.333313,1001.000000 339.666656,1001.000000 1.000000,1001.000000 
   C1.000000,667.666687 1.000000,334.333344 1.000000,1.000000 
   C339.666656,1.000000 678.333313,1.000000 1017.000000,1.000000 
   C1017.000000,125.833336 1017.000000,250.666672 1017.000000,376.000000 
M132.758148,756.771362 
   C169.326996,815.106140 216.447250,863.187134 274.137146,900.654114 
   C334.828827,940.070496 401.178772,964.365845 473.115570,973.324646 
   C507.663208,977.627075 542.230713,978.119568 576.805115,974.601746 
   C613.021057,970.916870 648.353333,963.010864 682.825745,951.158020 
   C745.788574,929.509094 801.641357,896.005066 850.264832,850.635986 
   C895.357056,808.561768 930.611267,759.263611 956.377930,703.206177 
   C981.281555,649.026367 995.310303,592.091003 998.543457,532.624939 
   C1000.538696,495.927856 998.068848,459.429352 991.287720,423.207031 
   C984.020813,384.390106 972.294739,347.041138 955.752808,311.233673 
   C925.939392,246.698471 883.638550,191.682098 828.751343,146.484650 
   C766.987305,95.624352 696.654541,62.652607 618.184814,47.364433 
   C571.960571,38.358612 525.345703,36.568424 478.465332,41.941292 
   C424.884369,48.082100 373.823334,62.771397 325.312653,86.281731 
   C267.914642,114.099258 218.293961,152.109741 176.456055,200.271530 
   C132.473175,250.902603 100.778313,308.399658 81.345062,372.499237 
   C65.160355,425.883667 58.579250,480.523407 62.126945,536.321777 
   C64.472458,573.212158 70.956116,609.338379 81.734901,644.651733 
   C93.745010,683.998962 110.581963,721.216248 132.758148,756.771362 
z"
                />
                <path
                  fill="#FDC905"
                  opacity="1.000000"
                  stroke="none"
                  d="
M132.567200,756.461060 
   C110.581963,721.216248 93.745010,683.998962 81.734901,644.651733 
   C70.956116,609.338379 64.472458,573.212158 62.126945,536.321777 
   C58.579250,480.523407 65.160355,425.883667 81.345062,372.499237 
   C100.778313,308.399658 132.473175,250.902603 176.456055,200.271530 
   C218.293961,152.109741 267.914642,114.099258 325.312653,86.281731 
   C373.823334,62.771397 424.884369,48.082100 478.465332,41.941292 
   C525.345703,36.568424 571.960571,38.358612 618.184814,47.364433 
   C696.654541,62.652607 766.987305,95.624352 828.751343,146.484650 
   C883.638550,191.682098 925.939392,246.698471 955.752808,311.233673 
   C972.294739,347.041138 984.020813,384.390106 991.287720,423.207031 
   C998.068848,459.429352 1000.538696,495.927856 998.543457,532.624939 
   C995.310303,592.091003 981.281555,649.026367 956.377930,703.206177 
   C930.611267,759.263611 895.357056,808.561768 850.264832,850.635986 
   C801.641357,896.005066 745.788574,929.509094 682.825745,951.158020 
   C648.353333,963.010864 613.021057,970.916870 576.805115,974.601746 
   C542.230713,978.119568 507.663208,977.627075 473.115570,973.324646 
   C401.178772,964.365845 334.828827,940.070496 274.137146,900.654114 
   C216.447250,863.187134 169.326996,815.106140 132.567200,756.461060 
M332.552734,894.033752 
   C364.343567,910.476990 397.741516,922.636475 432.563263,930.720093 
   C481.858490,942.163574 531.748535,944.845337 581.967407,938.770691 
   C625.696716,933.481018 667.754883,921.759399 707.964172,903.667786 
   C768.169922,876.578918 819.642090,837.843140 862.115479,787.297791 
   C904.794312,736.507935 934.342957,678.852051 950.728638,614.602783 
   C963.694031,563.764893 967.202942,512.206726 961.336121,459.975372 
   C956.086792,413.241699 943.633057,368.568878 923.977478,325.931183 
   C897.435974,268.356415 860.002258,218.936127 811.679260,177.851105 
   C755.501831,130.088150 691.194092,98.651070 619.168274,83.292244 
   C574.559204,73.779770 529.484009,71.700981 484.035248,76.627701 
   C432.672150,82.195549 383.872253,96.371407 337.625732,119.193352 
   C284.993134,145.166763 239.479492,180.476349 201.260635,225.069748 
   C156.715897,277.044098 126.097771,336.326538 109.300484,402.616272 
   C96.830017,451.830414 93.565063,501.796692 98.697212,552.345520 
   C102.674461,591.519165 112.000839,629.354614 126.245140,666.003601 
   C144.829330,713.818604 171.115112,756.999939 205.141098,795.370178 
   C241.215881,836.050598 283.430298,868.922485 332.552734,894.033752 
z"
                />
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M332.227051,893.852905 
   C283.430298,868.922485 241.215881,836.050598 205.141098,795.370178 
   C171.115112,756.999939 144.829330,713.818604 126.245140,666.003601 
   C112.000839,629.354614 102.674461,591.519165 98.697212,552.345520 
   C93.565063,501.796692 96.830017,451.830414 109.300484,402.616272 
   C126.097771,336.326538 156.715897,277.044098 201.260635,225.069748 
   C239.479492,180.476349 284.993134,145.166763 337.625732,119.193352 
   C383.872253,96.371407 432.672150,82.195549 484.035248,76.627701 
   C529.484009,71.700981 574.559204,73.779770 619.168274,83.292244 
   C691.194092,98.651070 755.501831,130.088150 811.679260,177.851105 
   C860.002258,218.936127 897.435974,268.356415 923.977478,325.931183 
   C943.633057,368.568878 956.086792,413.241699 961.336121,459.975372 
   C967.202942,512.206726 963.694031,563.764893 950.728638,614.602783 
   C934.342957,678.852051 904.794312,736.507935 862.115479,787.297791 
   C819.642090,837.843140 768.169922,876.578918 707.964172,903.667786 
   C667.754883,921.759399 625.696716,933.481018 581.967407,938.770691 
   C531.748535,944.845337 481.858490,942.163574 432.563263,930.720093 
   C397.741516,922.636475 364.343567,910.476990 332.227051,893.852905 
M489.907593,686.865906 
   C476.724670,684.990723 463.581421,682.733032 450.346405,681.360107 
   C439.556885,680.240906 428.837646,674.360474 417.519226,681.125061 
   C417.308563,678.828918 417.310791,677.361755 417.022797,675.953979 
   C415.031616,666.220947 413.678162,656.284363 410.754883,646.835449 
   C407.725281,637.042908 396.121521,634.127136 388.305359,640.303711 
   C382.980957,644.511230 381.357025,650.700745 383.929352,657.874451 
   C388.687408,671.143738 389.801453,684.665955 385.154694,698.021240 
   C382.172302,706.592957 377.962982,714.775879 373.858002,722.908142 
   C369.849854,730.848633 371.507904,739.062744 378.607391,743.414673 
   C385.625244,747.716614 394.275208,745.613281 398.843994,737.923889 
   C402.657349,731.505920 406.075287,724.812988 409.144196,718.005493 
   C411.608948,712.538208 413.288452,706.716858 415.101440,701.653076 
   C419.153503,703.570312 422.524384,706.081238 426.236572,706.780640 
   C465.892822,714.252625 505.911255,718.900574 546.225586,720.532166 
   C594.279724,722.476929 642.158752,720.031494 689.689331,712.566528 
   C736.178040,705.265259 781.584167,693.597351 825.555237,676.733582 
   C829.196411,675.337219 832.805786,671.821960 834.688232,668.347473 
   C837.598145,662.976746 836.303772,657.222900 831.869629,652.731201 
   C826.959290,647.757141 821.101379,647.396423 814.784302,649.737915 
   C783.367188,661.382996 751.274780,670.604736 718.461670,677.500549 
   C672.641724,687.129883 626.312500,692.112610 579.580627,691.648560 
   C549.978455,691.354553 520.400696,688.599487 489.907593,686.865906 
M764.120178,422.711975 
   C766.217896,419.580353 769.214417,416.717438 770.245850,413.267059 
   C773.433289,402.604553 776.173279,391.783051 778.517212,380.900574 
   C780.924805,369.721893 774.719360,360.452576 764.160217,358.431244 
   C754.056274,356.497009 746.031982,362.775391 743.662109,374.019196 
   C741.539856,384.088470 738.993591,394.068054 736.660095,404.093170 
   C734.857239,411.838593 736.832886,418.389221 743.427490,423.002289 
   C749.966736,427.576630 756.783325,427.469818 764.120178,422.711975 
M639.220459,398.781189 
   C640.846985,392.209076 643.292297,385.712036 643.903442,379.046814 
   C644.766235,369.636780 638.361023,362.436646 629.507446,361.161407 
   C620.303650,359.835754 612.910034,364.640625 609.912842,373.523346 
   C606.689575,383.076324 603.283813,392.571014 599.778015,402.024475 
   C596.397888,411.138916 600.095825,421.066345 608.483765,424.799316 
   C617.582886,428.848724 627.083008,425.522095 631.591736,416.388580 
   C634.306580,410.889191 636.530273,405.147308 639.220459,398.781189 
z"
                />
                <path
                  fill="#FDC907"
                  opacity="1.000000"
                  stroke="none"
                  d="
M490.359802,686.907043 
   C520.400696,688.599487 549.978455,691.354553 579.580627,691.648560 
   C626.312500,692.112610 672.641724,687.129883 718.461670,677.500549 
   C751.274780,670.604736 783.367188,661.382996 814.784302,649.737915 
   C821.101379,647.396423 826.959290,647.757141 831.869629,652.731201 
   C836.303772,657.222900 837.598145,662.976746 834.688232,668.347473 
   C832.805786,671.821960 829.196411,675.337219 825.555237,676.733582 
   C781.584167,693.597351 736.178040,705.265259 689.689331,712.566528 
   C642.158752,720.031494 594.279724,722.476929 546.225586,720.532166 
   C505.911255,718.900574 465.892822,714.252625 426.236572,706.780640 
   C422.524384,706.081238 419.153503,703.570312 415.101440,701.653076 
   C413.288452,706.716858 411.608948,712.538208 409.144196,718.005493 
   C406.075287,724.812988 402.657349,731.505920 398.843994,737.923889 
   C394.275208,745.613281 385.625244,747.716614 378.607391,743.414673 
   C371.507904,739.062744 369.849854,730.848633 373.858002,722.908142 
   C377.962982,714.775879 382.172302,706.592957 385.154694,698.021240 
   C389.801453,684.665955 388.687408,671.143738 383.929352,657.874451 
   C381.357025,650.700745 382.980957,644.511230 388.305359,640.303711 
   C396.121521,634.127136 407.725281,637.042908 410.754883,646.835449 
   C413.678162,656.284363 415.031616,666.220947 417.022797,675.953979 
   C417.310791,677.361755 417.308563,678.828918 417.519226,681.125061 
   C428.837646,674.360474 439.556885,680.240906 450.346405,681.360107 
   C463.581421,682.733032 476.724670,684.990723 490.359802,686.907043 
z"
                />
                <path
                  fill="#FDC908"
                  opacity="1.000000"
                  stroke="none"
                  d="
M763.806519,422.903748 
   C756.783325,427.469818 749.966736,427.576630 743.427490,423.002289 
   C736.832886,418.389221 734.857239,411.838593 736.660095,404.093170 
   C738.993591,394.068054 741.539856,384.088470 743.662109,374.019196 
   C746.031982,362.775391 754.056274,356.497009 764.160217,358.431244 
   C774.719360,360.452576 780.924805,369.721893 778.517212,380.900574 
   C776.173279,391.783051 773.433289,402.604553 770.245850,413.267059 
   C769.214417,416.717438 766.217896,419.580353 763.806519,422.903748 
z"
                />
                <path
                  fill="#FCC907"
                  opacity="1.000000"
                  stroke="none"
                  d="
M639.097534,399.147797 
   C636.530273,405.147308 634.306580,410.889191 631.591736,416.388580 
   C627.083008,425.522095 617.582886,428.848724 608.483765,424.799316 
   C600.095825,421.066345 596.397888,411.138916 599.778015,402.024475 
   C603.283813,392.571014 606.689575,383.076324 609.912842,373.523346 
   C612.910034,364.640625 620.303650,359.835754 629.507446,361.161407 
   C638.361023,362.436646 644.766235,369.636780 643.903442,379.046814 
   C643.292297,385.712036 640.846985,392.209076 639.097534,399.147797 
z"
                />
              </Svg>
            </ScoreBox>
            <ScoreBox
              onPanEnd={(e, info) => {
                console.log(isDropped[item.id - 4]);

                DragandDrop(info.point.x, info.point.y, item.id, 4, 10);
              }}
              style={{
                visibility: isDropped[item.id - 4]?.scorenum[3]?.dropped
                  ? "hidden"
                  : "block",
              }}
              variants={ScoreBoxVariants}
              drag
              whileHover="hover"
              whileTap="tap"
              initial="initial"
              animate="end"
              dragSnapToOrigin={true}
            >
              <Svg
                version="1.1"
                xmlns="http://www.w3.org/2000/Svg"
                x="0px"
                y="0px"
                width="100%"
                viewBox="0 0 1065 1000"
              >
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1066.000000,379.000000 
   C1066.000000,586.641602 1066.000000,793.783264 1066.000000,1000.962402 
   C711.067993,1000.962402 356.135986,1000.962402 1.101981,1000.962402 
   C1.101981,667.775024 1.101981,334.549957 1.101981,1.162450 
   C355.999939,1.162450 710.999939,1.162450 1066.000000,1.162450 
   C1066.000000,126.864159 1066.000000,252.682083 1066.000000,379.000000 
M77.097603,582.519653 
   C82.372803,601.242371 86.783501,620.261414 93.081467,638.633545 
   C113.962273,699.546082 147.105438,753.151917 191.683380,799.598206 
   C229.916351,839.433716 274.132080,871.021973 324.123535,894.499939 
   C378.955811,920.251404 436.694916,934.312073 497.170898,936.617432 
   C549.234619,938.602112 600.118958,931.350220 649.742859,915.316467 
   C730.705505,889.156921 799.060303,843.916260 853.821899,778.868835 
   C913.272217,708.252075 947.719238,626.727722 957.190369,534.776001 
   C961.783142,490.186584 959.503357,445.916168 950.496643,402.058624 
   C941.603943,358.756226 926.780273,317.526672 905.641479,278.633942 
   C866.202820,206.071762 810.902100,148.728531 739.817810,106.789696 
   C682.160706,72.772659 619.894897,52.774750 553.142212,46.706730 
   C518.444458,43.552612 483.879272,44.453053 449.473083,49.492580 
   C413.098206,54.820457 377.881500,64.544052 343.840454,78.594032 
   C269.625793,109.225075 207.957321,156.273438 159.324951,220.071457 
   C110.100441,284.646271 80.611328,357.404846 70.713158,438.092804 
   C64.795082,486.335785 67.086548,534.159851 77.097603,582.519653 
z"
                />
                <path
                  fill="#FDC905"
                  opacity="1.000000"
                  stroke="none"
                  d="
M77.043350,582.100464 
   C67.086548,534.159851 64.795082,486.335785 70.713158,438.092804 
   C80.611328,357.404846 110.100441,284.646271 159.324951,220.071457 
   C207.957321,156.273438 269.625793,109.225075 343.840454,78.594032 
   C377.881500,64.544052 413.098206,54.820457 449.473083,49.492580 
   C483.879272,44.453053 518.444458,43.552612 553.142212,46.706730 
   C619.894897,52.774750 682.160706,72.772659 739.817810,106.789696 
   C810.902100,148.728531 866.202820,206.071762 905.641479,278.633942 
   C926.780273,317.526672 941.603943,358.756226 950.496643,402.058624 
   C959.503357,445.916168 961.783142,490.186584 957.190369,534.776001 
   C947.719238,626.727722 913.272217,708.252075 853.821899,778.868835 
   C799.060303,843.916260 730.705505,889.156921 649.742859,915.316467 
   C600.118958,931.350220 549.234619,938.602112 497.170898,936.617432 
   C436.694916,934.312073 378.955811,920.251404 324.123535,894.499939 
   C274.132080,871.021973 229.916351,839.433716 191.683380,799.598206 
   C147.105438,753.151917 113.962273,699.546082 93.081467,638.633545 
   C86.783501,620.261414 82.372803,601.242371 77.043350,582.100464 
M906.725403,365.939850 
   C898.790100,346.377258 892.024414,326.238129 882.714905,307.352966 
   C844.531555,229.894455 787.002441,170.624924 711.405884,128.996033 
   C663.134216,102.414146 611.509033,86.390099 556.648743,80.581718 
   C525.339355,77.266823 494.078522,77.450760 462.918701,81.297516 
   C426.411835,85.804359 391.063507,95.115257 356.998016,109.162834 
   C282.176331,140.017044 221.532089,188.636047 175.113861,254.839096 
   C146.943359,295.016693 126.832657,339.018677 114.336891,386.527863 
   C106.808586,415.150574 102.322739,444.222717 101.151779,473.737366 
   C99.219826,522.432983 105.716347,570.015747 120.614761,616.507751 
   C139.153610,674.360168 168.781906,725.743286 209.908554,770.349060 
   C255.076065,819.337280 309.165649,855.172913 371.705109,878.261841 
   C409.785370,892.320618 449.109863,900.602356 489.576569,902.834106 
   C533.946411,905.280945 577.696411,900.942261 620.700989,889.224121 
   C662.974792,877.705139 702.552307,860.254883 739.187561,836.303162 
   C791.460327,802.127808 833.820984,758.259888 866.162964,704.802063 
   C904.047913,642.182190 923.941772,574.212158 925.989075,501.098755 
   C927.272705,455.261292 920.734619,410.448547 906.725403,365.939850 
z"
                />
                <path
                  fill="none"
                  opacity="1.000000"
                  stroke="none"
                  d="
M906.827576,366.324219 
   C920.734619,410.448547 927.272705,455.261292 925.989075,501.098755 
   C923.941772,574.212158 904.047913,642.182190 866.162964,704.802063 
   C833.820984,758.259888 791.460327,802.127808 739.187561,836.303162 
   C702.552307,860.254883 662.974792,877.705139 620.700989,889.224121 
   C577.696411,900.942261 533.946411,905.280945 489.576569,902.834106 
   C449.109863,900.602356 409.785370,892.320618 371.705109,878.261841 
   C309.165649,855.172913 255.076065,819.337280 209.908554,770.349060 
   C168.781906,725.743286 139.153610,674.360168 120.614761,616.507751 
   C105.716347,570.015747 99.219826,522.432983 101.151779,473.737366 
   C102.322739,444.222717 106.808586,415.150574 114.336891,386.527863 
   C126.832657,339.018677 146.943359,295.016693 175.113861,254.839096 
   C221.532089,188.636047 282.176331,140.017044 356.998016,109.162834 
   C391.063507,95.115257 426.411835,85.804359 462.918701,81.297516 
   C494.078522,77.450760 525.339355,77.266823 556.648743,80.581718 
   C611.509033,86.390099 663.134216,102.414146 711.405884,128.996033 
   C787.002441,170.624924 844.531555,229.894455 882.714905,307.352966 
   C892.024414,326.238129 898.790100,346.377258 906.827576,366.324219 
M514.682983,662.137085 
   C521.951965,657.758728 529.055542,653.073853 536.516296,649.051147 
   C590.520569,619.932800 648.525024,611.981567 708.838318,617.314392 
   C741.431702,620.196289 773.307007,627.046021 804.723816,636.200073 
   C808.381042,637.265747 813.104675,636.768433 816.719849,635.387756 
   C822.087952,633.337708 824.682495,627.410034 823.906738,621.802979 
   C822.902283,614.543457 818.069336,611.043335 811.433350,609.190308 
   C786.249207,602.157959 760.856384,596.147827 734.931519,592.468262 
   C701.628418,587.741333 668.274719,586.556030 634.793701,590.242981 
   C605.145935,593.507751 576.494934,600.670837 548.993103,612.246216 
   C496.643433,634.279968 454.357819,669.294250 419.119141,713.318176 
   C413.423370,720.433960 408.023590,727.786621 402.967896,734.400635 
   C395.238281,731.691345 388.170349,728.813843 380.866302,726.787476 
   C375.539825,725.309692 370.989136,727.831299 367.840759,732.204590 
   C364.698517,736.569153 364.233612,741.291260 366.669159,746.350403 
   C369.206482,751.620911 373.986511,753.232239 378.953308,754.868652 
   C391.567963,759.024902 398.376801,767.884094 399.124786,781.082642 
   C399.322510,784.571411 399.160522,788.078918 399.257782,791.575195 
   C399.486023,799.779236 405.209930,805.744751 412.932983,805.898193 
   C420.895142,806.056396 426.695557,800.160278 427.060822,791.635132 
   C427.521362,780.885376 426.500946,770.385559 422.792603,760.164246 
   C422.145996,758.382141 422.537109,755.462463 423.643066,753.929688 
   C430.555878,744.348694 437.508331,734.766357 445.005127,725.642578 
   C464.992035,701.318115 487.652924,679.848450 514.682983,662.137085 
M717.072693,360.812592 
   C714.596313,371.308167 712.088623,381.796448 709.653259,392.301514 
   C707.556824,401.344238 712.744873,410.368469 721.284363,412.671753 
   C729.745667,414.953888 738.912415,410.471527 741.334351,402.189240 
   C744.406982,391.681915 747.241394,381.068359 749.367798,370.339935 
   C750.157715,366.354553 749.443787,361.626404 748.023438,357.746674 
   C745.590515,351.101257 739.740234,348.350647 732.936035,348.391815 
   C725.060303,348.439392 719.970886,352.790710 717.072693,360.812592 
M620.966003,375.438934 
   C621.265442,372.464447 621.910767,369.476776 621.798096,366.518036 
   C621.488770,358.397064 615.491028,352.191345 607.372864,351.187805 
   C599.308899,350.190948 591.926147,354.873016 589.382507,362.360107 
   C586.185913,371.769073 582.890503,381.146027 579.506897,390.489410 
   C576.420105,399.012970 580.084534,408.201965 588.209106,411.884430 
   C596.335266,415.567596 605.962524,412.406647 609.760864,404.034729 
   C613.873840,394.969269 617.184875,385.539978 620.966003,375.438934 
z"
                />
                <path
                  fill="#FDC907"
                  opacity="1.000000"
                  stroke="none"
                  d="
M514.386230,662.343811 
   C487.652924,679.848450 464.992035,701.318115 445.005127,725.642578 
   C437.508331,734.766357 430.555878,744.348694 423.643066,753.929688 
   C422.537109,755.462463 422.145996,758.382141 422.792603,760.164246 
   C426.500946,770.385559 427.521362,780.885376 427.060822,791.635132 
   C426.695557,800.160278 420.895142,806.056396 412.932983,805.898193 
   C405.209930,805.744751 399.486023,799.779236 399.257782,791.575195 
   C399.160522,788.078918 399.322510,784.571411 399.124786,781.082642 
   C398.376801,767.884094 391.567963,759.024902 378.953308,754.868652 
   C373.986511,753.232239 369.206482,751.620911 366.669159,746.350403 
   C364.233612,741.291260 364.698517,736.569153 367.840759,732.204590 
   C370.989136,727.831299 375.539825,725.309692 380.866302,726.787476 
   C388.170349,728.813843 395.238281,731.691345 402.967896,734.400635 
   C408.023590,727.786621 413.423370,720.433960 419.119141,713.318176 
   C454.357819,669.294250 496.643433,634.279968 548.993103,612.246216 
   C576.494934,600.670837 605.145935,593.507751 634.793701,590.242981 
   C668.274719,586.556030 701.628418,587.741333 734.931519,592.468262 
   C760.856384,596.147827 786.249207,602.157959 811.433350,609.190308 
   C818.069336,611.043335 822.902283,614.543457 823.906738,621.802979 
   C824.682495,627.410034 822.087952,633.337708 816.719849,635.387756 
   C813.104675,636.768433 808.381042,637.265747 804.723816,636.200073 
   C773.307007,627.046021 741.431702,620.196289 708.838318,617.314392 
   C648.525024,611.981567 590.520569,619.932800 536.516296,649.051147 
   C529.055542,653.073853 521.951965,657.758728 514.386230,662.343811 
z"
                />
                <path
                  fill="#FDC908"
                  opacity="1.000000"
                  stroke="none"
                  d="
M717.146729,360.423065 
   C719.970886,352.790710 725.060303,348.439392 732.936035,348.391815 
   C739.740234,348.350647 745.590515,351.101257 748.023438,357.746674 
   C749.443787,361.626404 750.157715,366.354553 749.367798,370.339935 
   C747.241394,381.068359 744.406982,391.681915 741.334351,402.189240 
   C738.912415,410.471527 729.745667,414.953888 721.284363,412.671753 
   C712.744873,410.368469 707.556824,401.344238 709.653259,392.301514 
   C712.088623,381.796448 714.596313,371.308167 717.146729,360.423065 
z"
                />
                <path
                  fill="#FCC908"
                  opacity="1.000000"
                  stroke="none"
                  d="
M620.905823,375.854126 
   C617.184875,385.539978 613.873840,394.969269 609.760864,404.034729 
   C605.962524,412.406647 596.335266,415.567596 588.209106,411.884430 
   C580.084534,408.201965 576.420105,399.012970 579.506897,390.489410 
   C582.890503,381.146027 586.185913,371.769073 589.382507,362.360107 
   C591.926147,354.873016 599.308899,350.190948 607.372864,351.187805 
   C615.491028,352.191345 621.488770,358.397064 621.798096,366.518036 
   C621.910767,369.476776 621.265442,372.464447 620.905823,375.854126 
z"
                />
              </Svg>
            </ScoreBox>
          </ScoreGrid>
        </Container>
      ))}
      <motion.div id="progressY" style={{ scaleX }}></motion.div>
      <Footer>
        <img
          style={{ position: "absolute" }}
          src="img/뿡뿡심금.png"
          height="55rem"
          onClick={() => {
            nextPage();
          }}
        />
      </Footer>
    </Wrapper>
  );
}
export default Page2;
